<template lang="html">
  <div class="dib relative user-select-none">
    <v-btn @click.native="toggleDropdown()"
      :label="label"
      icon-code="keyboard_arrow_down"
      icon-pos="right"
      icon-class="f5 b mt1"
      class="dn db-ns bg-transparent b f6 hover-action font-futura"
    />
    <v-btn @click.native="toggleDropdown()"
      :label="label"
      icon-code="keyboard_arrow_up"
      icon-pos="right"
      icon-class="f5 b mt1"
      class="dn-ns bg-transparent b f6 hover-action font-futura"
    />
    <dropdown-container :open="open" @cancel="cancelDropdown">
      <div class="h-100 relative bg-white">
        <!-- Mobile top actions (close & reset) -->
        <div v-if="requiresApply"
          class="dn-ns w-100 h-mobile-bar ph2 dt bb b--moon-gray
          flex justify-between items-center bg-white z-999"
        >
          <v-btn @click.native="cancelDropdown()"
            iconCode="close"
            class="bg-transparent black b"
          />
          <v-btn @click.native="resetValues()"
            label="reset"
            class="bg-transparent black b font-futura-bold"
          />
        </div>

        <!-- Content -->
        <div id="content" class="absolute overflow-y-auto pv4
          relative-ns pv2-ns ph1-ns"
        >
          <slot>AdvanceSelect controls not loaded.</slot>
        </div>

        <!-- Non mobile bottom actions (apply & reset) -->
        <div v-if="requiresApply"
          class="dn db-ns pb1 pt2 cf"
        >
          <v-btn @click.native="resetValues()"
            label="reset"
            class="bg-transparent b f6 fl black hover-action font-futura-bold nl2"
          />
          <v-btn @click.native="confirmDropdown()"
            label="apply"
            class="interact-bg-action raise white b f6 fr mr1 font-futura-bold"
          />
        </div>

        <!-- Mobile bottom action (apply) -->
        <div class="dn-ns h-mobile-bar ph2 bg-white absolute
          bottom-0 w-100 z-999 flex items-center"
        >
          <v-btn @click.native="confirmDropdown()"
            label="apply"
            class="interact-bg-action raise white b w-100 font-futura-bold"
          />
        </div>
      </div>
    </dropdown-container>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import DropdownContainerComponent from '@/components/DropdownContainer';
import ButtonComponent from '@/components/Button';

export default {
  components: {
    'dropdown-container': DropdownContainerComponent,
    'v-btn': ButtonComponent
  },
  props: {
    label: {
      type: String,
      required: true,
      default: 'advanceselect'
    },
    requiresApply: {
      type: Boolean,
      default: false
    },
    fillWidth: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      open: false
    };
  },
  methods: {
    ...mapActions(['SET_SORTING']),
    toggleDropdown() {
      if (this.open) {
        this.cancelDropdown();
      } else {
        this.open = true;
      }
    },
    cancelDropdown() {
      this.open = false;
      this.$emit('cancel');
    },
    confirmDropdown() {
      this.open = false;
      this.SET_SORTING(true);
      setTimeout(() => {
        this.$emit('apply');
      }, 250, this);
      setTimeout(() => {
        this.SET_SORTING(false);
      }, 300, this);
      this.$ma.trackEvent({
        action: 'AdvanceSelect',
        properties: {
          category: 'UI'
        }
      });
    },
    resetValues() {
      this.$emit('reset');
    }
  }
};
</script>

<style lang="scss" scoped>
#content {
  top: $mobile-bar-height;
  bottom: $mobile-bar-height;

  @media screen and (min-width: 30em) {
    top: auto;
    bottom: auto;
    max-height: 80vh;
  }
}

.options {
  min-width: 175px;
}
</style>



// WEBPACK FOOTER //
// src/components/AdvanceSelect.vue